import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { WHATSAPP_DISPLAY, WHATSAPP_NUMBER } from "../lib/api";

export default function Footer() {
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hello RSN Gloves, I would like a quotation."
  )}`;

  return (
    <footer className="mt-16" data-testid="footer">
      <section className="bg-[#064E3B] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div>
            <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tight">
              Looking for a customised solution?
            </h2>
            <p className="text-white/75 mt-1">We are here to help.</p>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
            <Link to="/products" className="btn-primary text-center">
              Get Bulk Quote →
            </Link>
            <a href="tel:+918928341661" className="inline-flex items-center gap-2 text-sm font-semibold hover:text-[#84CC16]">
              <Phone className="w-4 h-4" /> {WHATSAPP_DISPLAY}
            </a>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold hover:text-[#84CC16]"
            >
              <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-[#DFE7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-9">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <img
                src="/images/brand/rsn-logo.webp"
                alt="RSN Gloves"
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-[#5F6B66] leading-relaxed mt-3">
              Hand protection for industrial, commercial and everyday applications.
            </p>
          </div>

          <div>
            <div className="font-display font-bold text-[#0F172A] mb-4">Quick Links</div>
            <ul className="space-y-2.5 text-sm text-[#5F6B66]">
              <li><Link to="/" className="hover:text-[#075B3A]">Home</Link></li>
              <li><Link to="/products" className="hover:text-[#075B3A]">Products</Link></li>
              <li><Link to="/about" className="hover:text-[#075B3A]">About</Link></li>
              <li><Link to="/dealer-enquiry" className="hover:text-[#075B3A]">Dealers</Link></li>
              <li><Link to="/contact" className="hover:text-[#075B3A]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-display font-bold text-[#0F172A] mb-4">Our Products</div>
            <ul className="space-y-2.5 text-sm text-[#5F6B66]">
              <li>
                <Link to="/products?category=Rubber%20Hand%20Gloves" className="hover:text-[#075B3A]">
                  Rubber Hand Gloves
                </Link>
              </li>
              <li>
                <Link to="/products?category=Cotton%20Hand%20Gloves" className="hover:text-[#075B3A]">
                  Cotton Hand Gloves
                </Link>
              </li>
              <li>
                <Link to="/products?category=Industrial%20Coated%20Hand%20Gloves" className="hover:text-[#075B3A]">
                  Industrial Coated Gloves
                </Link>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-2">
            <div className="font-display font-bold text-[#0F172A] mb-4">Contact Us</div>
            <ul className="space-y-3 text-sm text-[#5F6B66]">
              <li className="flex gap-2.5">
                <Phone className="w-4 h-4 mt-0.5 text-[#075B3A] shrink-0" />
                <a href="tel:+918928341661" className="hover:text-[#075B3A]">{WHATSAPP_DISPLAY}</a>
              </li>
              <li className="flex gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 text-[#075B3A] shrink-0" />
                <a href="mailto:ashish.arihantsales@gmail.com" className="hover:text-[#075B3A] break-all">
                  ashish.arihantsales@gmail.com
                </a>
              </li>
              <li className="flex gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 text-[#075B3A] shrink-0" />
                <span>Agrasen Chowk, Gandhibagh, Nagpur, Maharashtra – 440032</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#E9EFEB] py-5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row gap-2 justify-between text-xs text-[#748079]">
            <span>© {new Date().getFullYear()} RSN Gloves. All rights reserved.</span>
            <span>Made for Hands that Build India.</span>
          </div>
        </div>
      </section>
    </footer>
  );
}
